"use strict";
/**
 * @tama/game-core — the world's rules, as pure functions.
 *
 * This package has no runtime dependencies and never reads the clock: every
 * function takes what it needs as an argument. The API imports it to seed and
 * validate worlds, and the client imports the same code to move the pet around
 * one, which is why the two never disagree about what is solid.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
__exportStar(require("./types"), exports);
__exportStar(require("./objects"), exports);
__exportStar(require("./world"), exports);
__exportStar(require("./home"), exports);
__exportStar(require("./movement"), exports);
__exportStar(require("./pet"), exports);
var util_1 = require("./util");
Object.defineProperty(exports, "clamp", { enumerable: true, get: function () { return util_1.clamp; } });
//# sourceMappingURL=index.js.map